export default "__VITE_ASSET__DsS6ErL$__"